import React from "react";

import Svg, {
  Path,
  Defs,
  LinearGradient,
  Stop,
  Rect,
  G,
  ClipPath,
} from "react-native-svg";

export default function HiddenIcon(props) {
  const width = props.width || 26;
  const height = props.height || 26;
  const color = props.color || "#05858A";
  const color2 = props.color2 || "#2AE8CB";

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G clipPath="url(#clip0-hidden)">
        <Rect
          y="24.9165"
          width="34.6667"
          height="2.16667"
          rx="1.08333"
          transform="rotate(-45 0 24.9165)"
          fill="url(#paint0_linear-hidden)"
        />
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.29872 19.9511C10.4357 20.3427 11.6737 20.5832 12.9998 20.5832C19.9993 20.5832 24.5449 13.8849 24.7345 13.6011C24.8533 13.4231 24.9167 13.2138 24.9167 12.9998C24.9167 12.7858 24.8533 12.5766 24.7345 12.3986C24.6316 12.2446 23.2466 10.2026 20.8832 8.36653L16.7574 12.4924C16.78 12.6599 16.7915 12.8295 16.7915 12.9998C16.7915 14.0054 16.392 14.9699 15.681 15.6809C14.9699 16.392 14.0054 16.7915 12.9998 16.7915C12.8295 16.7915 12.6599 16.78 12.4924 16.7574L9.29872 19.9511ZM13.9598 9.33169C13.4065 9.18691 12.8254 9.16859 12.2601 9.28103C11.5246 9.42733 10.849 9.78845 10.3187 10.3187C9.78845 10.849 9.42733 11.5246 9.28103 12.2601C9.16859 12.8254 9.18691 13.4065 9.33169 13.9598L5.42444 17.867C2.87363 15.9749 1.37242 13.7616 1.26517 13.6011C1.14639 13.4231 1.08301 13.2138 1.08301 12.9998C1.08301 12.7858 1.14639 12.5766 1.26517 12.3986C1.45475 12.1148 6.00042 5.4165 12.9998 5.4165C14.4821 5.4165 15.8542 5.71688 17.0983 6.19311L13.9598 9.33169Z"
          fill="url(#paint1_linear-hidden)"
        />
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear-hidden"
          x1="-9.66226e-07"
          y1="25.3864"
          x2="0.0807226"
          y2="28.0255"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={color} />
          <Stop offset="1" stopColor={color2} />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear-hidden"
          x1="1.08301"
          y1="8.70566"
          x2="6.33255"
          y2="25.5617"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor={color} />
          <Stop offset="1" stopColor={color2} />
        </LinearGradient>
        <ClipPath id="clip0-hidden">
          <Rect width="26" height="26" fill="white" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}
